import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';

import { useHistory } from "react-router-dom";


let AccountOverdueButton = ({ ...props }) => {

    const history = useHistory();

    //default active text 
    let display_text = "On Time"; 
    //default active style
    let display_type = "success";

    let account = props.store.accounts.getById(props.accountId);

    let payPeriods = account.getPayPeriods();

    function redirectToAccountState(event) {
        let accountId = event.target.value;
        history.push("/staff/AccountStatus/" + accountId);
    }
    
    //It has late timesheets
    if (payPeriods["unsubmitted"].length > 3) {
        display_text = "Overdue"
        display_type = "danger"
    }

    return (
        <button onClick={redirectToAccountState} value={account.id} style={{ display: "block", border:"none" }} type="button" className={"badge badge-" + display_type} >
            {display_text}
        </button>
    )
}

AccountOverdueButton = observer(AccountOverdueButton)

export default AccountOverdueButton;